import { VoiceAiSummary } from '@sales-app/types/VoiceAiSummary'
import { gql } from 'graphql-request'

export namespace VoiceAiSummaryQueries {
  export const QUERY_KEY = 'voiceAiRecapSummary'

  export namespace GET_VOICE_AI_RECAP_SUMMARY {
    export type Response = { voiceAiRecapSummary: VoiceAiSummary | null }
  }

  export function getVoiceAiRecapSummary() {
    return gql`
      query voiceAiRecapSummary($externalCallId: String!) {
        voiceAiRecapSummary(externalCallId: $externalCallId) {
          externalCallId
          recapSummary
        }
      }
    `
  }
}
